'use client';

import { explorationFeatureFlagAtom } from './exploration-feature-flag-atom';
import { useHandleInitialFeatureFlags } from './use-handle-initial-feature-flags';
import { useAtomValue } from 'jotai';

// --------------------------------------------------------------------------

export const AnalyticsFeatureFlagInitializer = () => {
  const flags = useAtomValue(explorationFeatureFlagAtom);
  useHandleInitialFeatureFlags(flags);
  return null;
};
